import Icon from "@material-ui/icons/Person";
import CcaFixedLocationDropOffCreate from "./CcaFixedLocationDropOffCreate";
import CcaFixedLocationDropOffEdit from "./CcaFixedLocationDropOffEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaFixedLocationDropOffs",
  edit: CcaFixedLocationDropOffEdit,
  create: CcaFixedLocationDropOffCreate,
  icon: Icon,
};
